/* Version: 3.5.155 */
'use client';
import styled from 'styled-components';
import { typography } from '../../typography/typography.js';

// Styled components for Card
var CardWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__CardWrapper",
  componentId: "sc-1em65cu-0"
})(["font-family:", ";line-height:", ";background:", ";border:1px solid ", ";width:100%;color:", ";text-align:", ";display:flex;flex-direction:column;", ""], typography.fontFamily, typography.lineHeight, function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorPalette.neutralColors.light.shade_default;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref4) {
  var centered = _ref4.centered;
  return centered ? 'center' : 'inherit';
}, function (_ref5) {
  var cardStyle = _ref5.cardStyle;
  return cardStyle;
});
process.env.NODE_ENV !== "production" ? CardWrapper.displayName = 'CardWrapper' : undefined;

// Styled components for CardHeader
var CardHeaderWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__CardHeaderWrapper",
  componentId: "sc-1em65cu-1"
})(["padding:20px 20px 10px 20px;font-weight:600;font-size:", ";line-height:1.4;position:relative;", ";"], function (_ref6) {
  var fontSize = _ref6.fontSize;
  return fontSize;
}, function (_ref7) {
  var withAdornment = _ref7.withAdornment,
    adornmentColor = _ref7.adornmentColor,
    centered = _ref7.centered,
    theme = _ref7.theme;
  if (withAdornment) {
    return "\n        &:before {\n          content: \"\";\n          position: absolute;\n          left: ".concat(centered ? 'calc(50% - 16px)' : '20px', ";\n          bottom: 0px;\n          background-color: ").concat(adornmentColor ? adornmentColor : theme.colorPalette.primaryColors.main.shade_default, ";\n          height: 3px;\n          width: 32px;\n        }\n      ");
  }
  return "\n      & + div {\n        padding-top: 0px;\n      }\n    ";
});
process.env.NODE_ENV !== "production" ? CardHeaderWrapper.displayName = 'CardHeaderWrapper' : undefined;

// Styled components for CardImage
var StyledImage = /*#__PURE__*/styled.img.withConfig({
  displayName: "styledComponents__StyledImage",
  componentId: "sc-1em65cu-2"
})(["max-width:100%;width:100%;", ""], function (_ref8) {
  var cardImageStyle = _ref8.cardImageStyle;
  return cardImageStyle;
});
process.env.NODE_ENV !== "production" ? StyledImage.displayName = 'StyledImage' : undefined;

// Styled components for CardSeparator
var CardSeparatorWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__CardSeparatorWrapper",
  componentId: "sc-1em65cu-3"
})(["margin:0 20px;height:1px;background-color:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.colorPalette.neutralColors.light.shade_default;
});
process.env.NODE_ENV !== "production" ? CardSeparatorWrapper.displayName = 'CardSeparatorWrapper' : undefined;

// Styled components for CardContent
var CardContentWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__CardContentWrapper",
  componentId: "sc-1em65cu-4"
})(["padding:20px;font-weight:300;flex:1 1 auto;", " p:first-child{margin-top:0;}p:last-child{margin-bottom:0;}", ""], function (_ref10) {
  var isScrollable = _ref10.isScrollable,
    scrollSectionHeight = _ref10.scrollSectionHeight;
  if (isScrollable) {
    return "\n        height: ".concat(scrollSectionHeight, ";\n        overflow: auto;\n      ");
  }
  return '';
}, function (_ref11) {
  var contentStyle = _ref11.contentStyle;
  return contentStyle;
});
process.env.NODE_ENV !== "production" ? CardContentWrapper.displayName = 'CardContentWrapper' : undefined;

// Styled components for CardAction
var CardActionWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__CardActionWrapper",
  componentId: "sc-1em65cu-5"
})(["padding:5px;border-top:1px solid ", ";display:flex;justify-content:", ";", ""], function (_ref12) {
  var theme = _ref12.theme;
  return theme.colorPalette.neutralColors.light.shade_default;
}, function (_ref13) {
  var centered = _ref13.centered;
  return centered ? 'center' : 'left';
}, function (_ref14) {
  var cardActionStyle = _ref14.cardActionStyle;
  return cardActionStyle;
});
process.env.NODE_ENV !== "production" ? CardActionWrapper.displayName = 'CardActionWrapper' : undefined;

export { CardActionWrapper, CardContentWrapper, CardHeaderWrapper, CardSeparatorWrapper, CardWrapper, StyledImage };
